/** Reducer to create a new todo. */
import { addTodoForm } from 'shared/store/slices/todoListSlice';
/** Reducer to create a new history. */
import { addHistory } from 'shared/store/slices/historySlice';

/** Reducer to create a new row in the main table. */
import { addMainForm as addOimForm } from 'shared/store/slices/oim-mainUpdateSlice';
import { addMainForm as addOexForm } from 'shared/store/slices/oex-mainUpdateSlice';
import { addMainForm as addAimForm } from 'shared/store/slices/aim-mainUpdateSlice';
import { addMainForm as addAexForm } from 'shared/store/slices/aex-mainUpdateSlice';
import { addMainForm as addTruckingForm } from 'shared/store/slices/trucking-mainUpdateSlice';

/** Reducer to create a new row in the HBL table. */
import { addHBL as addOimHBL } from 'shared/store/slices/oim-hblUpdateSlice';
import { addHBL as addOexHBL } from 'shared/store/slices/oex-hblUpdateSlice';
import { addHBL as addAimHBL } from 'shared/store/slices/aim-hblUpdateSlice';
import { addHBL as addAexHBL } from 'shared/store/slices/aex-hblUpdateSlice';
import { addBOL as addTruckingBOL } from 'shared/store/slices/trucking-bolUpdateSlice';

/** Reducer to create a new row in the container table. */
import { addContainer as addOimContainer } from 'shared/store/slices/oim-containerUpdateSlice';
import { addContainer as addOexContainer } from 'shared/store/slices/oex-containerUpdateSlice';
import { addContainer as addAimContainer } from 'shared/store/slices/aim-containerUpdateSlice';
import { addContainer as addAexContainer } from 'shared/store/slices/aex-containerUpdateSlice';

/** Reducer to create a new row in the alias table. */
import { addAlias as addOimAlias } from 'shared/store/slices/oim-containerAliasUpdateSlice';

/** Reducer to create a new row in the status table. */
import { addStatus as addOimStatus } from 'shared/store/slices/oim-statusUpdateSlice';
import { addStatus as addOexStatus } from 'shared/store/slices/oex-statusUpdateSlice';
import { addStatus as addAimStatus } from 'shared/store/slices/aim-statusUpdateSlice';
import { addStatus as addAexStatus } from 'shared/store/slices/aex-statusUpdateSlice';
import { addStatus as addTruckingStatus } from 'shared/store/slices/trucking-statusUpdateSlice';

/** Reducer to create a new row in the rate table. */
import { addRate as addOimRate } from 'shared/store/slices/oim-rateUpdateSlice';
import { addRate as addOexRate } from 'shared/store/slices/oex-rateUpdateSlice';
import { addRate as addAimRate } from 'shared/store/slices/aim-rateUpdateSlice';
import { addRate as addAexRate } from 'shared/store/slices/aex-rateUpdateSlice';
import { addRate as addTruckingRate } from 'shared/store/slices/trucking-rateUpdateSlice';

/** Reducer to create a new row in the comment table. */
import { addComment as addOimComment } from 'shared/store/slices/oim-commentUpdateSlice';
import { addComment as addOexComment } from 'shared/store/slices/oex-commentUpdateSlice';
import { addComment as addAimComment } from 'shared/store/slices/aim-commentUpdateSlice';
import { addComment as addAexComment } from 'shared/store/slices/aex-commentUpdateSlice';
import { addComment as addTruckingComment } from 'shared/store/slices/trucking-commentUpdateSlice';

/** Reducer to create a new row in the dispute table. */
import { addDispute as addOimDispute } from 'shared/store/slices/oim-disputeUpdateSlice';
import { addDispute as addOexDispute } from 'shared/store/slices/oex-disputeUpdateSlice';
import { addDispute as addAimDispute } from 'shared/store/slices/aim-disputeUpdateSlice';
import { addDispute as addAexDispute } from 'shared/store/slices/aex-disputeUpdateSlice';
import { addDispute as addTruckingDispute } from 'shared/store/slices/trucking-disputeUpdateSlice';

/** Reducer to add a trade partner info in data entry. */
import { addTradePartner } from 'shared/store/slices/tradePartnerSlice';

/** Reducer to manage rate types in data entry. */
import { addRateType, updateRateType, deleteRateType } from 'shared/store/slices/rateTypeSlice';

/** Reducer to manage Rate Management's own search-result state, decoupled from the shipment-page rate slices. */
import {
    addRateManagementData,
    updateRateManagementData,
    deleteRateManagementData,
} from 'shared/store/slices/rateManagementSlice';

/** Reducer to delete a status message in data entry (targeted SidTarget broadcast on delete success). */
import { deleteStatusMessage } from 'shared/store/slices/statusMessageSlice';

/** Reducer to update a specific status in status editor. */
import { updateStatusEditor } from 'shared/store/slices/statusEditorSlice';

/** Reducer to update a trade partner and preset notes. */
import { updateTradePartner } from 'shared/store/slices/tradePartnerSlice';
import { updatePresetNote } from 'shared/store/slices/presetNoteSlice';

/** Reducer to update a sepecific object in todo list. */
import { setUpdateTodo } from 'shared/store/slices/todoListSlice';

/** Reducer to update a specific row in the accounting table. */
import { updateAccountingData } from 'shared/store/slices/accountingUpdateSlice';

/** Reducer to update a specific cell in the main table (included 'PRESET'). */
import { setMainUpdateData as setOimMainUpdateData } from 'shared/store/slices/oim-mainUpdateSlice';
import { setMainUpdateData as setOexMainUpdateData } from 'shared/store/slices/oex-mainUpdateSlice';
import { setMainUpdateData as setAimMainUpdateData } from 'shared/store/slices/aim-mainUpdateSlice';
import { setMainUpdateData as setAexMainUpdateData } from 'shared/store/slices/aex-mainUpdateSlice';
import { setMainUpdateData as setTruckingMainUpdateData } from 'shared/store/slices/trucking-mainUpdateSlice';

/** Reducer to update a specific cell in the HBL table. */
import { setHblUpdateData as setOimHblFormData } from 'shared/store/slices/oim-hblUpdateSlice';
import { setHblUpdateData as setOexHblFormData } from 'shared/store/slices/oex-hblUpdateSlice';
import { setHblUpdateData as setAimHblFormData } from 'shared/store/slices/aim-hblUpdateSlice';
import { setHblUpdateData as setAexHblFormData } from 'shared/store/slices/aex-hblUpdateSlice';
import { setBolUpdateData } from 'shared/store/slices/trucking-bolUpdateSlice';

/** Reducer to update a specific cell in the Container table. */
import { setContainerUpdateData as setOimContainerFormData } from 'shared/store/slices/oim-containerUpdateSlice';
import { setContainerUpdateData as setOexContainerFormData } from 'shared/store/slices/oex-containerUpdateSlice';
import { setContainerUpdateData as setAimContainerFormData } from 'shared/store/slices/aim-containerUpdateSlice';
import { setContainerUpdateData as setAexContainerFormData } from 'shared/store/slices/aex-containerUpdateSlice';

/** Reducer to update a specific cell in the alias table(split). */
import { setAliasUpdateData as setOimAliasFormData } from 'shared/store/slices/oim-containerAliasUpdateSlice';

/** Reducer to update a specific row in the status table. */
import { setStatusUpdate as setOimStatusUpdate } from 'shared/store/slices/oim-statusUpdateSlice';
import { setStatusUpdate as setOexStatusUpdate } from 'shared/store/slices/oex-statusUpdateSlice';
import { setStatusUpdate as setAimStatusUpdate } from 'shared/store/slices/aim-statusUpdateSlice';
import { setStatusUpdate as setAexStatusUpdate } from 'shared/store/slices/aex-statusUpdateSlice';
import { setStatusUpdate as setTruckingStatusUpdate } from 'shared/store/slices/trucking-statusUpdateSlice';

/** Reducer to update a specific cell in the rate table. */
import { setRateUpdateData as setOimRateUpdate } from 'shared/store/slices/oim-rateUpdateSlice';
import { setRateUpdateData as setOexRateUpdate } from 'shared/store/slices/oex-rateUpdateSlice';
import { setRateUpdateData as setAimRateUpdate } from 'shared/store/slices/aim-rateUpdateSlice';
import { setRateUpdateData as setAexRateUpdate } from 'shared/store/slices/aex-rateUpdateSlice';
import { setRateUpdateData as setTruckingRateUpdate } from 'shared/store/slices/trucking-rateUpdateSlice';

/** Reducer to update a specific cell in the comment table. */
import { setCommentUpdateData as setOimCommentUpdate } from 'shared/store/slices/oim-commentUpdateSlice';
import { setCommentUpdateData as setOexCommentUpdate } from 'shared/store/slices/oex-commentUpdateSlice';
import { setCommentUpdateData as setAimCommentUpdate } from 'shared/store/slices/aim-commentUpdateSlice';
import { setCommentUpdateData as setAexCommentUpdate } from 'shared/store/slices/aex-commentUpdateSlice';
import { setCommentUpdateData as setTruckingCommentUpdate } from 'shared/store/slices/trucking-commentUpdateSlice';

/** Reducer to update a specific cell in the dispute table. */
import { setDisputeUpdateData as setOimDisputeUpdate } from 'shared/store/slices/oim-disputeUpdateSlice';
import { setDisputeUpdateData as setOexDisputeUpdate } from 'shared/store/slices/oex-disputeUpdateSlice';
import { setDisputeUpdateData as setAimDisputeUpdate } from 'shared/store/slices/aim-disputeUpdateSlice';
import { setDisputeUpdateData as setAexDisputeUpdate } from 'shared/store/slices/aex-disputeUpdateSlice';
import { setDisputeUpdateData as setTruckingDisputeUpdate } from 'shared/store/slices/trucking-disputeUpdateSlice';

/** Reducer to update a specific row in the preset table (based on trade partner data). */
import { setPresetUpdateData as setOimPresetUpdateData } from 'shared/store/slices/oim-presetUpdateSlice';
import { setPresetUpdateData as setOexPresetUpdateData } from 'shared/store/slices/oex-presetUpdateSlice';
import { setPresetUpdateData as setAimPresetUpdateData } from 'shared/store/slices/aim-presetUpdateSlice';
import { setPresetUpdateData as setAexPresetUpdateData } from 'shared/store/slices/aex-presetUpdateSlice';
import { setPresetUpdateData as setTruckingPresetUpdateData } from 'shared/store/slices/trucking-presetUpdateSlice';

/** Reducer to delete specific todo data. */
import { setDeleteTodo } from 'shared/store/slices/todoListSlice';
import { replaceShipmentTodo, resetShipmentTodo } from 'shared/store/slices/shipmentTodoSlice';

/** Reducer to delete a specific row in the main table. */
import { setDeleteData as setOimDelete } from 'shared/store/slices/oim-mainUpdateSlice';
import { setDeleteData as setOexDelete } from 'shared/store/slices/oex-mainUpdateSlice';
import { setDeleteData as setAimDelete } from 'shared/store/slices/aim-mainUpdateSlice';
import { setDeleteData as setAexDelete } from 'shared/store/slices/aex-mainUpdateSlice';
import { setDeleteData as setTruckingDelete } from 'shared/store/slices/trucking-mainUpdateSlice';

/** Reducer to delete a specific row in the hbl table. */
import { deleteHBL as deleteOimHBL } from 'shared/store/slices/oim-hblUpdateSlice';
import { deleteHBL as deleteOexHBL } from 'shared/store/slices/oex-hblUpdateSlice';
import { deleteHBL as deleteAimHBL } from 'shared/store/slices/aim-hblUpdateSlice';
import { deleteHBL as deleteAexHBL } from 'shared/store/slices/aex-hblUpdateSlice';
import { deleteBOL } from 'shared/store/slices/trucking-bolUpdateSlice';

/** Reducer to delete a specific row in the container table. */
import { deleteContainer as deleteOimContainer } from 'shared/store/slices/oim-containerUpdateSlice';
import { deleteContainer as deleteOexContainer } from 'shared/store/slices/oex-containerUpdateSlice';
import { deleteContainer as deleteAimContainer } from 'shared/store/slices/aim-containerUpdateSlice';
import { deleteContainer as deleteAexContainer } from 'shared/store/slices/aex-containerUpdateSlice';

/** Reducer to delete a specific row in the alias table. */
import { deleteAlias as deleteOimAlias } from 'shared/store/slices/oim-containerAliasUpdateSlice';

/** Reducer to delete a specific row in the status table. */
import { deleteStatus as deleteOimStatus } from 'shared/store/slices/oim-statusUpdateSlice';
import { deleteStatus as deleteOexStatus } from 'shared/store/slices/oex-statusUpdateSlice';
import { deleteStatus as deleteAimStatus } from 'shared/store/slices/aim-statusUpdateSlice';
import { deleteStatus as deleteAexStatus } from 'shared/store/slices/aex-statusUpdateSlice';
import { deleteStatus as deleteTruckingStatus } from 'shared/store/slices/trucking-statusUpdateSlice';

/** Reducer to delete a specific row in the rate table. */
import { deleteRate as deleteOimRate } from 'shared/store/slices/oim-rateUpdateSlice';
import { deleteRate as deleteOexRate } from 'shared/store/slices/oex-rateUpdateSlice';
import { deleteRate as deleteAimRate } from 'shared/store/slices/aim-rateUpdateSlice';
import { deleteRate as deleteAexRate } from 'shared/store/slices/aex-rateUpdateSlice';
import { deleteRate as deleteTruckingRate } from 'shared/store/slices/trucking-rateUpdateSlice';

/** Reducer to delete a specific row in the filter table. */
import { deleteFilter } from 'shared/store/slices/filterViewListSlice';

/** Reducer to delete a specific row in the comment table. */
import { deleteComment as deleteOimComment } from 'shared/store/slices/oim-commentUpdateSlice';
import { deleteComment as deleteOexComment } from 'shared/store/slices/oex-commentUpdateSlice';
import { deleteComment as deleteAimComment } from 'shared/store/slices/aim-commentUpdateSlice';
import { deleteComment as deleteAexComment } from 'shared/store/slices/aex-commentUpdateSlice';
import { deleteComment as deleteTruckingComment } from 'shared/store/slices/trucking-commentUpdateSlice';

/** Reducer to delete a specific row in the dispute table. */
import { deleteDispute as deleteOimDispute } from 'shared/store/slices/oim-disputeUpdateSlice';
import { deleteDispute as deleteOexDispute } from 'shared/store/slices/oex-disputeUpdateSlice';
import { deleteDispute as deleteAimDispute } from 'shared/store/slices/aim-disputeUpdateSlice';
import { deleteDispute as deleteAexDispute } from 'shared/store/slices/aex-disputeUpdateSlice';
import { deleteDispute as deleteTruckingDispute } from 'shared/store/slices/trucking-disputeUpdateSlice';

/** Reducer to notify the user before the assignment-driven reload. */
import { setSnackbar, closeSnackbar } from 'shared/store/slices/snackBarSlice';

const reducers = {
    replaceShipmentTodo,
    resetShipmentTodo,
    addTodoForm,
    addHistory,
    addOimForm,
    addOexForm,
    addAimForm,
    addAexForm,
    addTruckingForm,
    addOimHBL,
    addOexHBL,
    addAimHBL,
    addAexHBL,
    addTruckingBOL,
    addOimContainer,
    addOexContainer,
    addAimContainer,
    addAexContainer,
    addOimAlias,
    addOimStatus,
    addOexStatus,
    addAimStatus,
    addAexStatus,
    addTruckingStatus,
    addOimRate,
    addOexRate,
    addAimRate,
    addAexRate,
    addTruckingRate,
    addOimComment,
    addOexComment,
    addAimComment,
    addAexComment,
    addTruckingComment,
    addOimDispute,
    addOexDispute,
    addAimDispute,
    addAexDispute,
    addTruckingDispute,
    addTradePartner,
    addRateType,
    updateRateType,
    deleteRateType,
    addRateManagementData,
    updateRateManagementData,
    deleteRateManagementData,
    deleteStatusMessage,
    updateTradePartner,
    updatePresetNote,
    setUpdateTodo,
    updateAccountingData,
    updateStatusEditor,
    setOimMainUpdateData,
    setOexMainUpdateData,
    setAimMainUpdateData,
    setAexMainUpdateData,
    setTruckingMainUpdateData,
    setOimHblFormData,
    setOexHblFormData,
    setAimHblFormData,
    setAexHblFormData,
    setBolUpdateData,
    setOimContainerFormData,
    setOexContainerFormData,
    setAimContainerFormData,
    setAexContainerFormData,
    setOimAliasFormData,
    setOimStatusUpdate,
    setOexStatusUpdate,
    setAimStatusUpdate,
    setAexStatusUpdate,
    setTruckingStatusUpdate,
    setOimRateUpdate,
    setOexRateUpdate,
    setAimRateUpdate,
    setAexRateUpdate,
    setTruckingRateUpdate,
    setOimCommentUpdate,
    setOexCommentUpdate,
    setAimCommentUpdate,
    setAexCommentUpdate,
    setTruckingCommentUpdate,
    setOimDisputeUpdate,
    setOexDisputeUpdate,
    setAimDisputeUpdate,
    setAexDisputeUpdate,
    setTruckingDisputeUpdate,
    setOimPresetUpdateData,
    setOexPresetUpdateData,
    setAimPresetUpdateData,
    setAexPresetUpdateData,
    setTruckingPresetUpdateData,
    setDeleteTodo,
    setOimDelete,
    setOexDelete,
    setAimDelete,
    setAexDelete,
    setTruckingDelete,
    deleteOimHBL,
    deleteOexHBL,
    deleteAimHBL,
    deleteAexHBL,
    deleteBOL,
    deleteOimContainer,
    deleteOexContainer,
    deleteAimContainer,
    deleteAexContainer,
    deleteOimAlias,
    deleteOimStatus,
    deleteOexStatus,
    deleteAimStatus,
    deleteAexStatus,
    deleteTruckingStatus,
    deleteOimRate,
    deleteOexRate,
    deleteAimRate,
    deleteAexRate,
    deleteTruckingRate,
    deleteFilter,
    deleteOimComment,
    deleteOexComment,
    deleteAimComment,
    deleteAexComment,
    deleteTruckingComment,
    deleteOimDispute,
    deleteOexDispute,
    deleteAimDispute,
    deleteAexDispute,
    deleteTruckingDispute,
};

export const handleSocketCreate = (receivedData, dispatch) => {
    console.log('Received data create:', receivedData);
    if (Array.isArray(receivedData[3])) {
        // New shipment create.
        const tableName = {
            0: ['il_ocean_import', 'il_ocean_import_hbl', 'il_ocean_import_cntr', 'il_rate'],
            1: ['il_ocean_export', 'il_ocean_export_hbl', 'il_ocean_export_cntr', 'il_rate'],
            2: ['il_air_import', 'il_air_import_hbl', 'il_air_import_hbl_alias', 'il_rate'],
            3: ['il_air_export', 'il_air_export_hbl', 'il_air_export_hbl_alias', 'il_rate'],
            4: ['il_ftl_ltl', 'il_ftl_ltl_alias', 'il_rate'],
        };

        const handlers = {
            main: receivedData[3][0],
            hbl: receivedData[3][1],
            container: receivedData[3][2],
            rate: receivedData[3][3],
        };

        const dataTypes = ['main', 'hbl', 'container', 'rate'];

        dataTypes.forEach((type, index) => {
            const data = receivedData[4][tableName[receivedData[0]][index]];
            if (data) {
                if (Array.isArray(data)) {
                    data.forEach((item) => dispatch(reducers[handlers[type]](item)));
                } else {
                    dispatch(reducers[handlers[type]](data));
                }
            }
        });
    } else {
        const handler = receivedData[3];
        dispatch(reducers[handler](receivedData[4]));
    }
};

const mainUpdateActionsByTab = {
    0: setOimMainUpdateData,
    1: setOexMainUpdateData,
    2: setAimMainUpdateData,
    3: setAexMainUpdateData,
    4: setTruckingMainUpdateData,
};

const pendingUpdates = {};

export const handleSocketUpdate = (receivedData, dispatch) => {
    console.log('Received data update:', receivedData);

    const reducerName = receivedData[3];
    const newData = receivedData[4];

    if (reducerName === 'addHistory') {
        const tabValue = receivedData[0];
        dispatch(reducers[reducerName]({ tabValue, newData }));
    } else if (reducerName === 'updateFromDocument') {
        const tabValue = receivedData[0];
        const action = mainUpdateActionsByTab[tabValue];
        if (action) dispatch(action(newData));
    } else if (receivedData[1] === 'cell') {
        const payload = receivedData[4];
        if (!payload || payload.id == null) return;

        const merge = { [payload.key]: payload.value };
        const relatedFields = ['feta', 'eta', 'etd', 'deta'];
        relatedFields.forEach((field) => {
            if (payload[field] !== undefined && payload.key !== field) {
                merge[field] = payload[field];
            }
        });

        // 같은 id의 업데이트를 합산
        const pendingKey = `${reducerName}_${payload.id}`;
        pendingUpdates[pendingKey] = {
            ...pendingUpdates[pendingKey],
            ...merge,
        };

        clearTimeout(pendingUpdates[pendingKey]?._timer);
        pendingUpdates[pendingKey]._timer = setTimeout(() => {
            const { _timer, ...finalMerge } = pendingUpdates[pendingKey];
            dispatch(reducers[reducerName]({ id: payload.id, newData: finalMerge }));
            delete pendingUpdates[pendingKey];
        }, 20);
    } else if (receivedData[1] === 'row') {
        if (Array.isArray(reducerName)) {
            reducerName.forEach((item) => dispatch(reducers[item](newData)));
        } else {
            dispatch(reducers[reducerName](newData));
        }
    } else;
};

/**
 * Takes deleted rows off the screen, exactly as a server delete broadcast does. The screen also
 * calls it when the server says a row is already gone, in case that broadcast never arrived.
 */
export const applySocketDelete = (reducerName, deletedIds, dispatch) => {
    dispatch(reducers[reducerName](deletedIds));
};

export const handleSocketDelete = (receivedData, dispatch) => {
    console.log('Received data delete:', receivedData);
    applySocketDelete(receivedData[3], receivedData[4], dispatch);
};

export const handleSocketRead = (receivedData, dispatch) => {
    console.log('Received data Read:', receivedData);
    const tabValue = receivedData[0];

    const actionsMap = {
        0: setOimMainUpdateData,
        1: setOexMainUpdateData,
        2: setAimMainUpdateData,
        3: setAexMainUpdateData,
        4: setTruckingMainUpdateData,
    };

    const keyName = {
        0: 'il_ocean_import_id',
        1: 'il_ocean_export_id',
        2: 'il_air_import_id',
        3: 'il_air_export_id',
        4: 'il_ftl_ltl_id',
    };

    if (actionsMap[tabValue]) {
        const key = receivedData[4][keyName[tabValue]];
        dispatch(
            actionsMap[tabValue]({
                id: key,
                newData: { [receivedData[2]]: receivedData[4] },
            })
        );
    }
};

/** Column labels for the auto-update notices. */
const AUTO_UPDATE_LABELS = {
    etd: 'ETD',
    eta: 'ETA',
    feta: 'F.ETA',
    deta: 'D.ETA',
    perdiem: 'Detention',
    alias_etd: 'Split ETD',
    alias_eta: 'Split ETA',
};

const autoUpdateLabel = (key) => AUTO_UPDATE_LABELS[key] ?? String(key ?? '').replace(/_/g, ' ').toUpperCase();


const MAX_QUEUED_AUTO_UPDATES = 6;

/** Columns still waiting for their turn in the shared snackbar. */
const autoUpdateQueue = [];
let autoUpdateTimer = null;

/** Show the next auto-updated column, then hand the snackbar to the one after it. */
const showNextAutoUpdateNotice = (dispatch) => {
    const notice = autoUpdateQueue.shift();
    if (!notice) {
        autoUpdateTimer = null;
        return;
    }

    // A cleared date is an automatic change too — saying "cleared" beats showing an empty value.
    const value = notice.value ? String(notice.value) : 'cleared';
    dispatch(
        setSnackbar({
            open: true,
            message: `${autoUpdateLabel(notice.key)} was updated automatically: ${value}`,
            severity: 'info',
            owner: 'autoUpdateNotice',
        }),
    );

    autoUpdateTimer = setTimeout(() => {
        if (autoUpdateQueue.length === 0) {
            autoUpdateTimer = null;
            return;
        }
        // Only if our own notice is still up — otherwise the message that replaced it belongs
        // to another feature and stays.
        dispatch(closeSnackbar({ owner: 'autoUpdateNotice' }));
        autoUpdateTimer = setTimeout(() => showNextAutoUpdateNotice(dispatch), 500);
    }, 2000);
};

export const handleAutoUpdateNotice = (receivedData, dispatch) => {
    console.log('Received auto update notice:', receivedData);
    const changes = receivedData?.[4]?.changes;
    if (!Array.isArray(changes) || changes.length === 0) return;

    autoUpdateQueue.push(...changes);
    if (autoUpdateQueue.length > MAX_QUEUED_AUTO_UPDATES) {
        autoUpdateQueue.splice(0, autoUpdateQueue.length - MAX_QUEUED_AUTO_UPDATES);
    }
    if (!autoUpdateTimer) showNextAutoUpdateNotice(dispatch);
};

/** Delay before the assignment-driven reload, so the user can read the notice first. */
const ASSIGNMENT_RELOAD_DELAY_MS = 3000;
let assignmentReloadTimer = null;

/**
 * Handle the 'assignments_changed' push — an administrator changed this user's team or
 * client assignments. The server has already corrected the session scope and notification
 * rooms; reloading is the only reliable way to clear data already rendered under the old
 * scope, because several screens skip re-fetching while their store is populated.
 */
export const handleAssignmentsChanged = (dispatch) => {
    if (assignmentReloadTimer) return;
    dispatch(
        setSnackbar({
            open: true,
            message: 'Your team or client assignments were updated by an administrator. The screen will reload shortly.',
            severity: 'info',
        }),
    );
    assignmentReloadTimer = setTimeout(() => window.location.reload(), ASSIGNMENT_RELOAD_DELAY_MS);
};
